export default __webpack_public_path__ + "static/media/drop-2-grey.cd605ae3.jpg";